import { SimpleIconProps } from '../types';

export const IconBoldCheckMark = ({ className, color }: SimpleIconProps) => (
  <svg
    className={className}
    fill="none"
    height="16"
    role="img"
    viewBox="0 0 20 16"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M6.9999 12.1996L2.7999 7.99961L1.3999 9.39961L6.9999 14.9996L18.9999 2.99961L17.5999 1.59961L6.9999 12.1996Z"
      fill={color}
      fillRule="evenodd"
      stroke={color}
    />
  </svg>
);
